export const CLASSIFICATION_ROOT_NODE_ID = 0;
export const CLASSIFICATION_ATC_NODE_ID = 1;
export const CLASSIFICATION_FORM_NODE_ID = 6980;
export const CLASSIFICATION_CATEGORY_DICT_NODE_ID = 6979;
